import React from 'react';
import { photoFilter, type SitePhoto } from '../../data/photos';
interface PhotoProps {
  photo: SitePhoto;
  /** Tailwind aspect class for the frame. */
  aspect?: string;
  caption?: boolean;
  className?: string;
  /** Use on images visible on first paint. */
  eager?: boolean;
  tone?: 'light' | 'dark';
}
export function Photo({
  photo,
  aspect = 'aspect-[4/3]',
  caption = true,
  className = '',
  eager = false,
  tone = 'light'
}: PhotoProps) {
  React.useEffect(ensureSharpenFilter, []);
  return <figure className={className} data-id="element-1334" data-mp="3529oxcqqe3yi">
      <div className={`overflow-hidden rounded-md bg-panel ${aspect}`} data-id="element-1335" data-mp="353ccpbsrbqa7">
        <img src={photo.src} alt={photo.alt} loading={eager ? 'eager' : 'lazy'} decoding="async" className="h-full w-full object-cover" style={{
        objectPosition: photo.position ?? '50% 50%',
        filter: photoFilter(photo)
      }} data-id="element-1336" data-mp="3a1m73k6nqmur" />
      </div>
      {caption && <figcaption className={`mt-3 text-small ${tone === 'dark' ? 'text-white/60' : 'text-muted'}`} data-id="element-1337" data-mp="2mb0dgxxeh54a">{photo.caption}</figcaption>}
    </figure>;
}

/** Adds one shared SVG unsharp filter to the page, referenced by every photo as url(#cavalla-sharpen). */
export function ensureSharpenFilter() {
  if (typeof document === 'undefined' || document.getElementById('cavalla-sharpen')) return;
  const ns = 'http://www.w3.org/2000/svg';
  const svg = document.createElementNS(ns, 'svg');
  svg.setAttribute('aria-hidden', 'true');
  svg.setAttribute('width', '0');
  svg.setAttribute('height', '0');
  svg.style.position = 'absolute';
  const filter = document.createElementNS(ns, 'filter');
  filter.setAttribute('id', 'cavalla-sharpen');
  filter.setAttribute('color-interpolation-filters', 'sRGB');
  const matrix = document.createElementNS(ns, 'feConvolveMatrix');
  matrix.setAttribute('order', '3');
  matrix.setAttribute('preserveAlpha', 'true');
  // A gentle sharpen kernel: weights sum to 1 so brightness is unchanged.
  matrix.setAttribute('kernelMatrix', '0 -0.45 0 -0.45 2.8 -0.45 0 -0.45 0');
  filter.appendChild(matrix);
  svg.appendChild(filter);
  document.body.appendChild(svg);
}